export function shouldUseFrontEndServerTranslations(): boolean {
	return process.env.NODE_ENV === 'production' || !!process.env.DEV_USE_SERVER_TRANSLATIONS;
}
